var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor" },
    [
      _c("editor-menu-bar", {
        attrs: { editor: _vm.editor },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var commands = ref.commands
              var isActive = ref.isActive
              return [
                _c("div", { staticClass: "menubar" }, [
                  _c(
                    "button",
                    {
                      staticClass: "menubar__button",
                      class: { "is-active": isActive.paragraph() },
                      attrs: { type: "button" },
                      on: { click: commands.paragraph },
                    },
                    [_c("i", { staticClass: "fa fa-paragraph" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "menubar__button",
                      class: { "is-active": isActive.heading({ level: 1 }) },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return commands.heading({ level: 1 })
                        },
                      },
                    },
                    [_vm._v("\n                  H1\n              ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "menubar__button",
                      class: { "is-active": isActive.heading({ level: 2 }) },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return commands.heading({ level: 2 })
                        },
                      },
                    },
                    [_vm._v("\n                  H2\n              ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "menubar__button",
                      class: { "is-active": isActive.heading({ level: 3 }) },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return commands.heading({ level: 3 })
                        },
                      },
                    },
                    [_vm._v("\n                  H3\n              ")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "px-2" }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "menubar__button",
                      class: { "is-active": isActive.bullet_list() },
                      attrs: { type: "button" },
                      on: { click: commands.bullet_list },
                    },
                    [_c("i", { staticClass: "fa fa-list-ul" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "menubar__button",
                      class: { "is-active": isActive.ordered_list() },
                      attrs: { type: "button" },
                      on: { click: commands.ordered_list },
                    },
                    [_c("i", { staticClass: "fa fa-list-ol" })]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "px-2" }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "menubar__button",
                      class: { "is-active": isActive.bold() },
                      attrs: { type: "button" },
                      on: { click: commands.bold },
                    },
                    [_c("i", { staticClass: "fa fa-bold" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "menubar__button",
                      class: { "is-active": isActive.italic() },
                      attrs: { type: "button" },
                      on: { click: commands.italic },
                    },
                    [_c("i", { staticClass: "fa fa-italic" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "menubar__button",
                      class: { "is-active": isActive.underline() },
                      attrs: { type: "button" },
                      on: { click: commands.underline },
                    },
                    [_c("i", { staticClass: "fa fa-underline" })]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("EditorContent", {
        staticClass: "editor__content formated-content",
        class: { "editor__is-invalid": _vm.isInvalid },
        attrs: { editor: _vm.editor },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }